import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'stringifyArray',
  pure: true
})
export class StringifyArrayPipe implements PipeTransform {

  transform(array: any[], key: string): string {
    let value = '';
    for (let i = 0; i < array.length; i++) {
      value += (array[i][key] + (i < array.length - 1 ? ', ' : ''));
    }
    return value;
  }

}
